import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './QuestionAnswerSlideV4.css';

const cx = classnames.bind(styles);
const DELAY = 600;

function QuestionAnswerSlideV4({ question, answers, submitAnswer, userResponse, description, submitTemporaryAnswer, id, delay, tipText }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    useEffect(() => {
        if (userResponse.id && userResponse.isPending) {
            setIsPending(true);

            const { isPending: isTemporaryPending, ...answerData } = userResponse; /* eslint-disable-line */

            setTimeout(() => {
                submitAnswer(answerData)();
            }, delay);
        }
    }, [userResponse.id, userResponse.isPending]);

    const handleChange = answer => () => {
        if (isPending) return;

        submitTemporaryAnswer({ ...answer, questionId: id, question, isPending: true });
    };

    return (
        <div className={styles.form} key={id}>
            <p className={styles.question}>{question}</p>
            {Boolean(description) && <p className={styles.description}>{description}</p>}
            {Boolean(tipText) && (
                <div className={styles.tipBlock}>
                    <Icon name='bulb' />
                    <p>{tipText}</p>
                </div>
            )}
            <ul className={styles.answers}>
                {answers.map(answer => {
                    const isChecked = userResponse?.id === answer.id;
                    const classes = cx({
                        answer: true,
                        checked: isChecked
                    });

                    return (
                        <li key={answer.id} className={classes}>
                            <button
                                type='button'
                                onClick={handleChange(answer)}
                                className={styles.answerButton}
                                aria-pressed={isChecked}
                            >
                                {answer.text}
                                <span
                                    className={styles.answerIcon}
                                    aria-hidden='true'
                                >
                                    <Icon name='checked' />
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

QuestionAnswerSlideV4.propTypes = {
    question: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    description: PropTypes.string,
    tipText: PropTypes.string,
    delay: PropTypes.number
};

QuestionAnswerSlideV4.defaultProps = {
    userResponse: {},
    description: '',
    delay: DELAY
};

export {
    QuestionAnswerSlideV4
};
